import { ReceiptCreateBody } from "constants/types/receipt";
import * as yup from "yup";
import {
  BankAccountFormValues,
  PaymentMethod,
  emptyBankAccount,
} from "../BankAccountFields/config";

export type { PaymentMethod };

export interface ReceiptFormValues {
  amount: number | "";
  paymentDate: Date | null;
  bankAccount: BankAccountFormValues;
  notes: string;
}

export const initialValues = (defaultAmount: number): ReceiptFormValues => ({
  amount: defaultAmount,
  paymentDate: new Date(),
  bankAccount: emptyBankAccount(),
  notes: "",
});

export const toCreateBody = (
  values: ReceiptFormValues,
  saleOrderId: string,
  paymentMethod: PaymentMethod,
): ReceiptCreateBody => ({
  saleOrderId,
  amount: values.amount as number,
  paymentDate: Math.floor((values.paymentDate as Date).getTime() / 1000),
  ...(paymentMethod === "bank" && {
    bankAccount: {
      ...(values.bankAccount.id ? { id: values.bankAccount.id } : {}),
      bankName: values.bankAccount.bankName,
      accountNumber: values.bankAccount.accountNumber,
      accountHolder: values.bankAccount.accountHolder,
      isActive: values.bankAccount.isActive,
    },
  }),
  notes: values.notes || undefined,
});

export const validationSchema = (maxAmount: number, paymentMethod: PaymentMethod) =>
  yup.object({
    amount: yup
      .number()
      .typeError("Vui lòng nhập số tiền")
      // Đơn 0 đồng có maxAmount = 0 nên buộc phải cho nhập 0, không thì không
      // bao giờ tất toán được. Các đơn còn lại vẫn phải thu > 0 như cũ.
      .min(
        maxAmount === 0 ? 0 : 1,
        maxAmount === 0 ? "Số tiền phải bằng 0" : "Số tiền phải lớn hơn 0",
      )
      .max(maxAmount, `Số tiền không được vượt quá ${maxAmount.toLocaleString("vi-VN")} đ`)
      .required("Vui lòng nhập số tiền"),
    paymentDate: yup.date().required("Vui lòng chọn ngày thu").nullable(),
    bankAccount: paymentMethod === "bank"
      ? yup.object({
          id: yup.string(),
          bankName: yup.string().required("Vui lòng nhập tên ngân hàng"),
          accountNumber: yup.string().required("Vui lòng nhập số tài khoản"),
          accountHolder: yup.string().required("Vui lòng nhập chủ tài khoản"),
        })
      : yup.object().optional(),
    notes: yup.string().optional(),
  });
